(function () {
  'use strict';

  if (window.UKLedLightsSwitchboard && typeof window.UKLedLightsSwitchboard.init === 'function') {
    window.UKLedLightsSwitchboard.init(document);
    return;
  }

  var states = new WeakMap();

  function metresFromValue(value) {
    var match = String(value || '').trim().match(/^(\d+(?:[.,]\d+)?)\s*(?:m|metres?|meters?)$/i);
    return match ? parseFloat(match[1].replace(',', '.')) : null;
  }

  function requestedMetres(input) {
    var value = String(input.value || '').trim().replace(',', '.');
    if (!value) return null;
    if (!/^\d+(?:\.\d+)?$/.test(value)) return NaN;
    var number = parseFloat(value);
    return Number.isFinite(number) && number > 0 ? number : NaN;
  }

  function configuredMaximumMetres(root) {
    var value = String(root.dataset.maxMtmMetres || '').trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(value)) return null;
    var number = parseFloat(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function productArea(root) {
    return root.closest('.js-product');
  }

  function variantPicker(root) {
    var area = productArea(root);
    return area ? area.querySelector('variant-picker') : null;
  }

  function formForRoot(root) {
    return document.getElementById(root.dataset.productFormId);
  }

  function labelForField(field) {
    var label = field.dataset.optionName || '';
    if (!label) {
      var node = field.querySelector('legend, label');
      label = node ? node.textContent : '';
    }
    return String(label).trim().toLowerCase();
  }

  function choicesForField(field) {
    return Array.prototype.slice.call(field.querySelectorAll('input[type="radio"], option, .custom-select__option[data-value]')).map(function (choice) {
      var value = choice.dataset && Object.prototype.hasOwnProperty.call(choice.dataset, 'value') ? choice.dataset.value : choice.value;
      return {
        node: choice,
        value: value,
        metres: metresFromValue(value),
        available:
          choice.dataset.variantAvailable !== 'false' &&
          choice.getAttribute('aria-disabled') !== 'true' &&
          !choice.disabled &&
          !choice.classList.contains('is-unavailable') &&
          !choice.classList.contains('is-nonexistent')
      };
    }).filter(function (choice) {
      return choice.metres !== null;
    });
  }

  function lengthField(picker) {
    var fields = Array.prototype.slice.call(picker.querySelectorAll('.option-selector'));
    var named = fields.find(function (field) {
      var label = labelForField(field);
      return label === 'length' || label === 'size';
    });
    if (named && choicesForField(named).length) return named;
    return fields.find(function (field) {
      var choices = choicesForField(field);
      return choices.length > 1;
    }) || null;
  }

  function choiceLabel(field, choice) {
    if (!choice || choice.tagName !== 'INPUT' || !choice.id) return null;
    return Array.prototype.slice.call(field.querySelectorAll('label[for]')).find(function (label) {
      return label.htmlFor === choice.id;
    }) || null;
  }

  function saveAttribute(node, attribute, key) {
    if (!node || Object.prototype.hasOwnProperty.call(node.dataset, key)) return;
    node.dataset[key] = node.hasAttribute(attribute) ? node.getAttribute(attribute) : '__ukl_missing__';
  }

  function restoreAttribute(node, attribute, key) {
    if (!node || !Object.prototype.hasOwnProperty.call(node.dataset, key)) return;
    var value = node.dataset[key];
    if (value === '__ukl_missing__') {
      node.removeAttribute(attribute);
    } else {
      node.setAttribute(attribute, value);
    }
    delete node.dataset[key];
  }

  function setChoiceAboveMaximum(field, choice, aboveMaximum) {
    var label = choiceLabel(field, choice);

    if (aboveMaximum) {
      if (choice.dataset.uklOverLengthCap !== 'true') {
        saveAttribute(choice, 'hidden', 'uklCapOriginalHidden');
        saveAttribute(choice, 'disabled', 'uklCapOriginalDisabled');
        saveAttribute(choice, 'tabindex', 'uklCapOriginalTabindex');
        saveAttribute(choice, 'aria-hidden', 'uklCapOriginalAriaHidden');
        choice.dataset.uklCapHadDisabledClass = choice.classList.contains('is-disabled') ? 'true' : 'false';

        if (label) {
          saveAttribute(label, 'hidden', 'uklCapOriginalHidden');
          saveAttribute(label, 'aria-hidden', 'uklCapOriginalAriaHidden');
          label.dataset.uklOverLengthCap = 'true';
        }
      }

      choice.dataset.uklOverLengthCap = 'true';
      choice.hidden = true;
      choice.setAttribute('aria-hidden', 'true');
      choice.setAttribute('tabindex', '-1');
      if ('disabled' in choice) choice.disabled = true;
      if (choice.classList.contains('custom-select__option')) choice.classList.add('is-disabled');

      if (label) {
        label.hidden = true;
        label.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (choice.dataset.uklOverLengthCap !== 'true') return;

    restoreAttribute(choice, 'hidden', 'uklCapOriginalHidden');
    restoreAttribute(choice, 'disabled', 'uklCapOriginalDisabled');
    restoreAttribute(choice, 'tabindex', 'uklCapOriginalTabindex');
    restoreAttribute(choice, 'aria-hidden', 'uklCapOriginalAriaHidden');
    if (choice.dataset.uklCapHadDisabledClass !== 'true') choice.classList.remove('is-disabled');
    delete choice.dataset.uklCapHadDisabledClass;
    delete choice.dataset.uklOverLengthCap;

    if (label && label.dataset.uklOverLengthCap === 'true') {
      restoreAttribute(label, 'hidden', 'uklCapOriginalHidden');
      restoreAttribute(label, 'aria-hidden', 'uklCapOriginalAriaHidden');
      delete label.dataset.uklOverLengthCap;
    }
  }

  function choicePriority(choice) {
    if (choice.classList && choice.classList.contains('custom-select__option')) return 3;
    if (choice.tagName === 'INPUT') return 2;
    return 1;
  }

  function fallbackLengthChoice(picker, field, choices, maximum) {
    var candidates = choices.map(function (choice) {
      return {
        choice: choice,
        variant: choice.metres <= maximum ? resourceVariant(picker, field, choice) : null
      };
    }).filter(function (candidate) {
      return Boolean(candidate.variant);
    }).sort(function (left, right) {
      if (left.choice.metres !== right.choice.metres) return right.choice.metres - left.choice.metres;
      return choicePriority(right.choice.node) - choicePriority(left.choice.node);
    });

    return candidates.find(function (candidate) {
      return candidate.variant.available !== false && candidate.choice.available;
    }) || candidates.find(function (candidate) {
      return candidate.variant.available !== false;
    }) || candidates[0] || null;
  }

  function activeLengthMetres(root, picker, field) {
    var data = productData(picker);
    var product = data && data.product ? data.product : null;
    var fields = Array.prototype.slice.call(picker.querySelectorAll('.option-selector'));
    var optionIndex = fields.indexOf(field);
    var variantId = activeVariantId(root);
    if (!product || optionIndex < 0 || !variantId) return null;
    var variant = product.variants.find(function (item) {
      return String(item.id) === variantId;
    });
    return variant ? metresFromValue(variant.options[optionIndex]) : null;
  }

  function lengthPickerReady(picker, field) {
    if (!window.customElements || typeof window.customElements.get !== 'function') return false;
    var PickerClass = window.customElements.get('variant-picker');
    if (!PickerClass || !(picker instanceof PickerClass)) return false;

    var customSelect = field.querySelector('custom-select');
    if (!customSelect) return true;
    var CustomSelectClass = window.customElements.get('custom-select');
    return Boolean(
      CustomSelectClass &&
      customSelect instanceof CustomSelectClass &&
      typeof customSelect.selectOption === 'function'
    );
  }

  function scheduleLengthMaximum(root, state) {
    if (!state || state.lengthCapFrame) return;
    state.lengthCapFrame = window.requestAnimationFrame(function () {
      state.lengthCapFrame = null;
      if (root.isConnected) syncLengthMaximum(root, state);
    });
  }

  function waitForLengthPicker(root, state) {
    if (!state || state.lengthCapReadyPending || !window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    var picker = variantPicker(root);
    var field = picker ? lengthField(picker) : null;
    if (!field) return;

    var definitions = [window.customElements.whenDefined('variant-picker')];
    if (field.querySelector('custom-select')) definitions.push(window.customElements.whenDefined('custom-select'));

    state.lengthCapReadyPending = true;
    Promise.all(definitions).then(function () {
      state.lengthCapReadyPending = false;
      scheduleLengthMaximum(root, state);
    });
  }

  function syncLengthMaximum(root, state) {
    if (state && state.syncingLengthCap) return;

    var picker = variantPicker(root);
    var field = picker ? lengthField(picker) : null;
    if (!field) return;

    var maximum = configuredMaximumMetres(root);
    var choices = choicesForField(field);
    if (!choices.length) return;

    if (state) state.syncingLengthCap = true;
    try {
      choices.forEach(function (choice) {
        setChoiceAboveMaximum(field, choice.node, maximum !== null && choice.metres > maximum);
      });

      // A direct link can point at a legacy variant above the confirmed run
      // length. Keep the selected SKU, price, URL and cart variant aligned by
      // moving it to the longest valid variant for the same colour/options.
      var selectedMetres = metresFromValue(selectedValue(field));
      var activeMetres = activeLengthMetres(root, picker, field);
      var selectionExceedsMaximum = selectedMetres !== null && selectedMetres > maximum;
      var activeVariantExceedsMaximum = activeMetres !== null && activeMetres > maximum;
      if (
        maximum !== null &&
        (selectionExceedsMaximum || activeVariantExceedsMaximum) &&
        !(state && state.active) &&
        lengthPickerReady(picker, field)
      ) {
        var fallback = fallbackLengthChoice(picker, field, choices, maximum);
        if (fallback && setChoice(field, fallback.choice.node)) {
          // A custom-select may have measured the deep-linked, now-hidden
          // option while its custom element was upgrading. Re-measure after
          // the valid fallback is selected so the button label cannot clip.
          refreshCustomSelectWidth(field);
        }
      }
    } finally {
      if (state) state.syncingLengthCap = false;
    }
  }

  function selectedValue(field) {
    var selected = field.querySelector('input[type="radio"]:checked, option:checked, .custom-select__option[aria-selected="true"]');
    if (selected) {
      return selected.dataset && Object.prototype.hasOwnProperty.call(selected.dataset, 'value') ? selected.dataset.value : selected.value;
    }
    var customSelect = field.querySelector('custom-select');
    if (customSelect && customSelect.selectedOption) {
      return choiceValue(customSelect.selectedOption);
    }
    var dropdownText = field.querySelector('.custom-select__btn span');
    return dropdownText ? dropdownText.textContent.trim() : '';
  }

  function productData(picker) {
    var script = picker ? picker.querySelector('script[type="application/json"]') : null;
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (_error) {
      return null;
    }
  }

  function resourceVariant(picker, field, choice) {
    var data = productData(picker);
    var product = data && data.product ? data.product : null;
    if (!product || !choice) return null;
    var fields = Array.prototype.slice.call(picker.querySelectorAll('.option-selector'));
    var optionIndex = fields.indexOf(field);
    if (optionIndex < 0) return null;
    var selectedOptions = fields.map(function (optionField, index) {
      return index === optionIndex ? choice.value : selectedValue(optionField);
    });
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    }) || null;
  }

  function setChoice(field, choice) {
    if (!choice) return false;
    if (choice.tagName === 'OPTION') {
      var select = choice.closest('select');
      if (!select) return false;
      select.value = choice.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    if (choice.classList && choice.classList.contains('custom-select__option')) {
      var customSelect = choice.closest('custom-select');
      if (!customSelect || typeof customSelect.selectOption !== 'function') return false;
      customSelect.selectOption(choice);
      return true;
    }
    choice.checked = true;
    choice.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function refreshCustomSelectWidth(field) {
    var customSelect = field ? field.querySelector('custom-select') : null;
    if (!customSelect || typeof customSelect.setButtonWidth !== 'function') return;
    window.requestAnimationFrame(function () {
      if (customSelect.isConnected) customSelect.setButtonWidth();
    });
  }

  function formatMoney(pennies, currency) {
    if (!Number.isFinite(Number(pennies))) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(Number(pennies) / 100);
    } catch (_error) {
      return '£' + (Number(pennies) / 100).toFixed(2);
    }
  }

  function replaceToken(template, token, value) {
    return String(template || '').split(token).join(value);
  }

  function chargeMessage(root, metres, variant) {
    var displayMetres = Number(metres) % 1 === 0 ? String(parseInt(metres, 10)) : String(metres);
    if (variant && Number(variant.price) > 0 && metres > 0) {
      var rate = formatMoney(Number(variant.price) / metres, root.dataset.currency);
      var message = replaceToken(root.dataset.messageCharge, '[metres]', displayMetres);
      return replaceToken(message, '[rate]', rate);
    }
    return replaceToken(root.dataset.messageChargeNoRate, '[metres]', displayMetres);
  }

  function showState(root, message, active) {
    var status = root.querySelector('[data-ukl-switchboard-status]');
    var clear = root.querySelector('[data-ukl-switchboard-clear]');
    if (status) status.textContent = message || '';
    if (clear) clear.hidden = !active;
    root.classList.toggle('is-active', Boolean(active));
  }

  function propertyValue(root, input) {
    var metres = requestedMetres(input);
    if (!Number.isFinite(metres)) return '';

    var unit = String(root.dataset.propertyUnit || 'metres').trim();
    if (unit) unit = unit.charAt(0).toUpperCase() + unit.slice(1);
    return String(metres) + (unit ? ' ' + unit : '');
  }

  function setPropertyActive(root, input, active) {
    var property = root.querySelector('[data-ukl-switchboard-cut-property]');

    // The visible input stays numeric for editing and validation. A separate
    // successful control sends the fulfilment-ready value to Shopify once the
    // matching price variant has been verified.
    input.removeAttribute('name');
    if (!property) return;

    property.value = active ? propertyValue(root, input) : '';
    property.disabled = !active;
    if (active && property.dataset.propertyName) {
      property.setAttribute('name', property.dataset.propertyName);
    } else {
      property.removeAttribute('name');
    }
  }

  function lockLengthField(root, locked) {
    var picker = variantPicker(root);
    var field = picker ? lengthField(picker) : null;
    if (field) {
      field.inert = Boolean(locked);
      field.setAttribute('aria-disabled', locked ? 'true' : 'false');
      field.classList.toggle('ukl-switchboard-length-locked', Boolean(locked));
    }
  }

  function clearValidity(input) {
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');
  }

  function setValidity(input, message) {
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', 'true');
  }

  function choiceValue(choice) {
    if (!choice) return '';
    if (choice.dataset && Object.prototype.hasOwnProperty.call(choice.dataset, 'value')) {
      return choice.dataset.value;
    }
    return choice.value || '';
  }

  function activeVariantId(root) {
    var form = formForRoot(root);
    var input = form ? form.querySelector('input[name="id"]') : null;
    if (!input || input.disabled) return '';
    return String(input.value || '');
  }

  function restore(root, state, announce) {
    var picker = variantPicker(root);
    var input = root.querySelector('[data-ukl-switchboard-cut-length]');
    lockLengthField(root, false);
    state.active = false;
    if (input) setPropertyActive(root, input, false);

    if (picker && state.hasSnapshot) {
      var field = lengthField(picker);
      if (field && selectedValue(field) !== state.snapshotValue) {
        var snapshotChoice = Array.prototype.slice.call(
          field.querySelectorAll('input[type="radio"], option, .custom-select__option[data-value]')
        ).find(function (choice) {
          return choiceValue(choice) === state.snapshotValue;
        });
        if (snapshotChoice) setChoice(field, snapshotChoice);
      }
    }

    state.snapshotValue = '';
    state.hasSnapshot = false;
    showState(root, announce ? root.dataset.messageRestored : '', false);
  }

  function applyLength(root) {
    var state = states.get(root);
    var input = root.querySelector('[data-ukl-switchboard-cut-length]');
    if (!state || !input) return;

    var metres = requestedMetres(input);
    if (metres === null) {
      clearValidity(input);
      restore(root, state, state.active);
      return;
    }
    if (!Number.isFinite(metres)) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageUnavailable);
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    var picker = variantPicker(root);
    var field = picker ? lengthField(picker) : null;
    var choices = field ? choicesForField(field) : [];
    if (!choices.length) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageUnavailable);
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    choices.sort(function (left, right) { return left.metres - right.metres; });
    var nativeMax = choices[choices.length - 1].metres;
    var configuredMax = configuredMaximumMetres(root);
    var max = configuredMax === null ? nativeMax : Math.min(nativeMax, configuredMax);
    if (metres > max) {
      restore(root, state, false);
      var maxLabel = Number(max) % 1 === 0 ? String(parseInt(max, 10)) + 'm' : String(max) + 'm';
      var limitMessage = replaceToken(root.dataset.messageLimit, '[max]', maxLabel);
      setValidity(input, limitMessage);
      showState(root, limitMessage, false);
      return;
    }

    // Customers can enter the finished length they need. Production rounds the
    // cut to the nearest physical cut point; pricing still uses the next whole
    // metre variant so the storefront and cart charge the same amount.
    var requiredMetres = Math.ceil(metres);
    var target = choices.find(function (choice) {
      return choice.metres === requiredMetres && choice.metres <= max;
    });
    if (!target || (!target.available && target.node.dataset.uklOverLengthCap !== 'true')) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageUnavailable);
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    clearValidity(input);
    if (!state.active) {
      state.snapshotValue = selectedValue(field);
      state.hasSnapshot = true;
    }

    var currentValue = selectedValue(field);
    var variant = resourceVariant(picker, field, target);
    if (!variant || variant.available === false) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageUnavailable);
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    if (currentValue !== target.value) {
      state.applyingVariant = true;
      var selectionChanged = setChoice(field, target.node);
      state.applyingVariant = false;
      if (!selectionChanged) {
        restore(root, state, false);
        setValidity(input, root.dataset.messageSelectionFailed);
        showState(root, root.dataset.messageSelectionFailed, false);
        return;
      }
    }

    var pickerVariantId = picker.variant && picker.variant.id ? String(picker.variant.id) : '';
    if (pickerVariantId !== String(variant.id) || activeVariantId(root) !== String(variant.id)) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageSelectionFailed);
      showState(root, root.dataset.messageSelectionFailed, false);
      return;
    }

    state.active = true;
    setPropertyActive(root, input, true);
    lockLengthField(root, true);
    showState(root, chargeMessage(root, target.metres, variant), true);
  }

  function guardSubmit(root, event) {
    var input = root.querySelector('[data-ukl-switchboard-cut-length]');
    if (!input) return;
    applyLength(root);
    if (!input.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
      input.focus();
    }
  }

  function sanitiseCutFormData(root, formData) {
    if (!formData) return;
    var cutProperty = root.querySelector('[data-ukl-switchboard-cut-property]');
    if (!cutProperty) return;
    var cutKeyPattern = /^(?:(?:required|custom)\s*)?cut[\s_-]*length$/i;
    Array.from(formData.keys()).forEach(function (key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && cutKeyPattern.test(match[1])) formData.delete(key);
    });
    if (!cutProperty.disabled && cutProperty.name && String(cutProperty.value || '').trim()) {
      formData.set(cutProperty.name, cutProperty.value);
    }
    var optionsKey = 'properties[_gpo_options]';
    var optionsRaw = formData.get(optionsKey);
    if (!optionsRaw) return;
    try {
      var options = JSON.parse(optionsRaw);
      if (!options || typeof options !== 'object' || Array.isArray(options)) return;
      Object.keys(options).forEach(function (key) {
        if (cutKeyPattern.test(key)) delete options[key];
      });
      formData.set(optionsKey, JSON.stringify(options));
    } catch (error) {
      return;
    }
  }

  function gpoFieldName(element) {
    if (!element) return '';
    var input = element.querySelector('[data-field-name], [data-name]');
    var label = element.querySelector('.gpo-label, label');
    return String(
      (input && (input.dataset.fieldName || input.dataset.name)) ||
      (label && label.textContent) ||
      ''
    ).trim().toLowerCase();
  }

  function normalisedGpoFieldName(element) {
    return gpoFieldName(element)
      .replace(/^properties\[(.+)\]$/, '$1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isCableField(element) {
    var name = normalisedGpoFieldName(element);
    return name === 'cable length' || name === 'extension cable length';
  }

  function matchingCableContainer(root) {
    var section = root.closest('.cc-main-product') || productArea(root) || document;
    var containers = Array.prototype.slice.call(section.querySelectorAll('.gpo-container'));

    return containers.map(function (container) {
      var fields = Array.prototype.slice.call(container.querySelectorAll('.gpo-element'));
      var cables = fields.filter(function (element) {
        return isCableField(element) && Boolean(element.querySelector('.gpo-dropdown'));
      });
      if (cables.length !== 1) return null;

      var cable = cables[0];
      var hasOtherOptions = fields.some(function (element) {
        var isScopedFrontCap = element.getAttribute('data-element-id') === 'image-swatches-1' &&
          normalisedGpoFieldName(element) === 'front cap connection' &&
          Boolean(element.closest('.gpo-app[data-option-set-id="1758111"]'));
        var isScopedIp67Exit = element.getAttribute('data-element-id') === 'image-swatches-1' &&
          normalisedGpoFieldName(element) === 'cable exit' &&
          Boolean(element.closest('.gpo-app[data-option-set-id="1774206"]'));
        return element !== cable && normalisedGpoFieldName(element) !== 'required cut length' && !isScopedFrontCap && !isScopedIp67Exit;
      });
      var appBlock = container.closest('.shopify-app-block') || container;
      if (hasOtherOptions || appBlock.querySelectorAll('.gpo-container').length !== 1) return null;

      return { container: container, cable: cable, appBlock: appBlock };
    }).find(Boolean) || null;
  }

  function improveCableDropdownAccessibility(cable) {
    var dropdown = cable.querySelector('.gpo-dropdown');
    var button = cable.querySelector('.dropdown-button');
    var list = cable.querySelector('.dropdown-list');
    if (!dropdown || !button || !list) return;

    if (!list.id) {
      list.id = 'ukl-cable-options-' + Math.random().toString(36).slice(2, 9);
    }

    function syncState() {
      var expanded = dropdown.classList.contains('expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      list.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }

    button.setAttribute('aria-controls', list.id);
    list.setAttribute('role', 'listbox');

    // Globo can render a dropdown with its `expanded` class already applied.
    // Always initialise the relocated cable selector closed; later user clicks
    // continue to use Globo's own open/close behaviour.
    if (button.dataset.uklKeyboardReady !== 'true') {
      dropdown.classList.remove('expanded');
    }
    syncState();

    if (button.dataset.uklKeyboardReady === 'true') return;

    button.dataset.uklKeyboardReady = 'true';
    button.setAttribute('role', 'button');
    button.setAttribute('tabindex', '0');
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-label', normalisedGpoFieldName(cable) === 'cable length' ? 'Cable Length' : 'Extension Cable Length');
    button.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      button.click();
    });

    new MutationObserver(syncState).observe(dropdown, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function mountCableOptions(root) {
    var slot = root.querySelector('[data-ukl-switchboard-cable-slot]');
    var match = matchingCableContainer(root);
    if (!slot || !match) return false;
    var container = match.container;
    var cable = match.cable;

    // Switchboard owns the cut-length field. Keep any legacy Globo copy out of
    // the order form while retaining Globo's priced cable add-on integration.
    container.querySelectorAll('.gpo-element').forEach(function (element) {
      if (gpoFieldName(element).indexOf('required cut length') === -1) return;
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      element.querySelectorAll('input, select, textarea').forEach(function (input) {
        input.disabled = true;
      });
    });

    var appBlock = match.appBlock;
    if (!slot.contains(appBlock)) {
      var sourceBlock = appBlock.closest('.product-info__block');
      slot.appendChild(appBlock);
      if (sourceBlock && !sourceBlock.contains(slot)) {
        sourceBlock.classList.add('ukl-switchboard-gpo-source-empty');
      }
    }

    cable.classList.add('ukl-switchboard-cable-field');
    improveCableDropdownAccessibility(cable);
    container.dataset.uklSwitchboardMounted = 'true';
    slot.hidden = false;
    root.classList.add('has-cable-options');
    return true;
  }

  function observeCableOptions(root, state) {
    if (mountCableOptions(root)) {
      if (state.cableObserver) state.cableObserver.disconnect();
      if (state.cableTimeout) window.clearTimeout(state.cableTimeout);
      state.cableObserver = null;
      state.cableTimeout = null;
      return;
    }
    if (state.cableObserver) return;

    var section = root.closest('.cc-main-product') || productArea(root) || document.body;
    var observer = new MutationObserver(function () {
      if (!root.isConnected || !mountCableOptions(root)) return;
      observer.disconnect();
      window.clearTimeout(state.cableTimeout);
      state.cableObserver = null;
      state.cableTimeout = null;
    });

    state.cableObserver = observer;
    observer.observe(section, { childList: true, subtree: true });
    state.cableTimeout = window.setTimeout(function () {
      observer.disconnect();
      state.cableObserver = null;
      state.cableTimeout = null;
    }, 15000);
  }

  function initRoot(root) {
    if (states.has(root)) {
      var existingState = states.get(root);
      syncLengthMaximum(root, existingState);
      waitForLengthPicker(root, existingState);
      observeCableOptions(root, existingState);
      return;
    }
    var input = root.querySelector('[data-ukl-switchboard-cut-length]');
    var clear = root.querySelector('[data-ukl-switchboard-clear]');
    var form = formForRoot(root);
    var picker = variantPicker(root);
    if (!input || !clear || !form || !picker) return;
    if (!lengthField(picker)) {
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    var state = {
      active: false,
      applyingVariant: false,
      cableObserver: null,
      cableTimeout: null,
      hasSnapshot: false,
      lengthCapFrame: null,
      lengthCapReadyPending: false,
      snapshotValue: '',
      syncingLengthCap: false
    };
    states.set(root, state);
    setPropertyActive(root, input, false);
    input.disabled = false;
    observeCableOptions(root, state);

    input.addEventListener('input', function () { applyLength(root); });
    input.addEventListener('change', function () { applyLength(root); });
    clear.addEventListener('click', function () {
      input.value = '';
      clearValidity(input);
      restore(root, state, true);
      input.focus();
    });
    form.addEventListener('submit', function (event) { guardSubmit(root, event); }, true);
    form.addEventListener('formdata', function (event) { sanitiseCutFormData(root, event.formData); });

    picker.addEventListener('on:variant:change', function () {
      if (state.syncingLengthCap) return;
      if (state.active && !state.applyingVariant) applyLength(root);
      if (!state.active && !state.applyingVariant) scheduleLengthMaximum(root, state);
      observeCableOptions(root, state);
    });

    syncLengthMaximum(root, state);
    waitForLengthPicker(root, state);
    if (requestedMetres(input) !== null) applyLength(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-ukl-switchboard-customise]').forEach(initRoot);
  }

  window.UKLedLightsSwitchboard = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
